import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserModulePushOutput } from 'infrastructure/graphql/messaging/user/model/user-module-push.output';

import { ApiQuery } from '../../../../common/model/api.query';

export interface FetchUserModulePushesInput {
	readonly userId: string;
	readonly contactId?: string;
}

export interface FetchUserModulePushesParams {
	input: FetchUserModulePushesInput;
}

@Injectable({ providedIn: 'root' })
export class FetchUserModulePushesApiQuery extends ApiQuery<
	UserModulePushOutput[],
	FetchUserModulePushesParams
> {
	client = 'messaging';
	document = gql`
		query FetchUserModulePushes($input: FetchUserModulePushesInput!) {
			fetchUserModulePushes(input: $input) {
				contactEmailAddress
				pushOrgModuleId
				contactLanguage
				contactName
				contactId
				emailId
				status
			}
		}
	`;
	method = 'fetchUserModulePushes';
}
